import { useMemo } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { useEditCanvasStore } from '../../store';
import { useCommandHistory } from '../commands/hooks/useCommandHistory';

export function useUndoRedoShortcuts() {
  const undo = useCommandHistory((state) => state.undo);
  const redo = useCommandHistory((state) => state.redo);
  const readOnly = useEditCanvasStore((state) => state.readOnly);

  const options = useMemo(() => ({ enabled: !readOnly, preventDefault: true }), [readOnly]);

  useHotkeys('meta+z,ctrl+z', () => undo(), options, [undo, options]);

  useHotkeys('meta+shift+z,ctrl+shift+z', () => redo(), options, [redo, options]);
}
